import styled, { Interpolation } from '@emotion/styled';
import DefaultButton from './DefaultButton';
import { ReactNode } from 'react';
import { Theme } from '@emotion/react';
import { Variant } from './makeBtnSize';

const SecondaryButtonStyled = styled(DefaultButton)`
	color: ${({ theme }) => theme.colors.brand.main};
	background-color: transparent;
	border: 1px solid currentColor;
	justify-content: center;

	&:disabled {
	}

	&:hover:not(:disabled) {
		color: white;
		background-color: ${({ theme }) => theme.colors.brand.main};
		border-color: transparent;
	}
`;

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
	icon?: ReactNode;
	children?: ReactNode;
	xStyle?: Interpolation<Theme>;
	variant?: Variant;
	disabled?: boolean;
};

export const SecondaryButton = ({ icon = null, children = '', variant = 'large', xStyle = {}, disabled = false, ...props }: Props) => {
	return (
		<SecondaryButtonStyled variant={variant} disabled={disabled} css={xStyle} {...props}>
			{icon ? <span className="icon">{icon}</span> : null}
			{children}
		</SecondaryButtonStyled>
	);
};
